<ng-container *ngIf="hasPendingActivationRequests$ | async">
  <div class="banner-container">
    <glxy-alert
      type="info"
      [showAction]="true"
      actionTitle="View accounts"
      (actionClick)="routeToPendingActivationsRequest()"
    >
      <strong>You have accounts that need your attention -</strong>
      One or more accounts have pending activations that require your approval
    </glxy-alert>
  </div>
</ng-container>
